import React from 'react';
import ReactDOM from 'react-dom';
const KEY_ESC = 27;
const KEY_ENTER = 13;

class InstantEditBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isEditMode: false,
			value: props.model
		};
	}

	enterEditMode() {
		this.isCancelled = false;
		this.latestValue = this.state.value;
		this.setState({
			isEditMode: true
		});
    }

	commitValue(e) {
        if(this.isCancelled) {
            this.setState({
                isEditMode: false,
                value: this.latestValue
            });
        }
        else {
            let trimmedValue = e.target.value.trim();
            if(trimmedValue != null && trimmedValue != ""){
                this.setState({
                    isEditMode: false,
                    value: e.target.value
                });
                if(e.target.value != this.latestValue) {
                    this.props.onChange.call(null, e.target.value);
                }
            }
            else{
                alert("위젯의 이름을 입력해야 합니다.");
                this.setState({
                    isEditMode: false,
                    value: this.latestValue
                });
            }
        }
    }

    handleChange(e) {
        this.setState({
            value: e.target.value
        });
    }

    handleKeydown(e) {
        if(e.keyCode === KEY_ESC || e.keyCode === KEY_ENTER) {
            if(e.keyCode === KEY_ESC) {
                this.isCancelled = true;
            }
            let trimmedValue = e.target.value.trim();
            if(trimmedValue != null && trimmedValue != ""){
                var dom = ReactDOM.findDOMNode(this.refs.nameInput)
                if(!!dom) {
                    dom.blur();
                } 
            }
            else{
                alert("위젯의 이름을 입력해야 합니다.");
                this.isCancelled = true;
            }
        }
    }

	render() {
		// remove 'position:absolute' for IE11(#2729)
		if(this.state.isEditMode) {
			return (
				<input type="text"
							 ref="nameInput"
							 style={{zIndex:20}}
							 value={this.state.value}
							 onChange={this.handleChange.bind(this)}
							 onBlur={this.commitValue.bind(this)}
							 onKeyDown={this.handleKeydown.bind(this)}></input>)
		}
		else {
			return (<a style={{zIndex:20}} onClick={this.enterEditMode.bind(this)}>{this.state.value}</a>);
		}
	}

	componentDidUpdate() {
		var dom = ReactDOM.findDOMNode(this.refs.nameInput)
		if(!!dom) {
			dom.focus();
		}
	}

	componentWillReceiveProps(nextProps) {
		if(!this.state.isEditMode){
			this.setState({
				value: nextProps.model
			});
		}
	}
}

export default InstantEditBox;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/InstantEditBox.jsx